import React from 'react';
import { observer } from 'mobx-react-lite';

import { WidgetTexts } from 'widget/consts/texts';
import { WidgetConsentsType } from 'widget/entities/config';
import { useSubmissionFormStore } from 'widget/hooks/useSubmissionFormStore';

import styles from './ConsentsBlock.module.scss';
import ConsentsItem from './ConsentsItem';

const CONSENT_TEXTS_MAP = {
  [WidgetConsentsType.personalData]:
    WidgetTexts.submissionForm.consents.personalData,
  [WidgetConsentsType.mailing]: WidgetTexts.submissionForm.consents.mailing
} as const;

const ConsentsBlock: React.FC = () => {
  const submissionFormStore = useSubmissionFormStore();

  if (
    !submissionFormStore ||
    submissionFormStore.enabledConsents.length === 0
  ) {
    return null;
  }

  return (
    <div className={styles['consents']}>
      {submissionFormStore.enabledConsents.map((consent) => {
        const texts = CONSENT_TEXTS_MAP[consent.type];
        if (!texts) {
          return null;
        }
        return (
          <ConsentsItem
            key={consent.type}
            consent={consent}
            isChecked={submissionFormStore.getConsentValue(consent.type)}
            onChange={submissionFormStore.setConsentValue}
            disabled={submissionFormStore.isInputDisabled}
            linkText={texts.forLink}
            label={texts.label}
          />
        );
      })}
    </div>
  );
};

export default observer(ConsentsBlock);
